import React, { ReactChild, TableHTMLAttributes } from 'react'

export interface ITableProps extends TableHTMLAttributes<HTMLTableElement> {
  children: ReactChild | ReactChild[];
}

export default function Table({children, ...props}: ITableProps) {
  return (
    <table {...props}>
      {children}
    </table>
  )
}
